import { render } from "./RequestsReceived.vue?vue&type=template&id=ad850c3e&scoped=true"
import script from "./RequestsReceived.vue?vue&type=script&lang=js"
export * from "./RequestsReceived.vue?vue&type=script&lang=js"

import "./RequestsReceived.vue?vue&type=style&index=0&id=ad850c3e&scoped=true&lang=css"

import exportComponent from "/Users/josecisneros/Desktop/Jose-Cisneros/Portfolio-Site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad850c3e"]])

export default __exports__